import Cookies from 'js-cookie';

export const LAST_LOGGED_IN_USER_ID_KEY = 'lastLoggedInUserId';

const AUTH_COOKIE_NAMES = [
  'token',
  'refreshToken',
  'userId',
  'userRole',
  'userRoleId',
  'userDesignation',
  'userVertical',
  'userDesignationLevel',
  'userName',
  'userEmail',
  'domino_enabled'
];

export function saveAuthSessionCookies({ token, refreshToken, domino_enabled, user } = {}) {
  Cookies.set('token', token);
  if (refreshToken) {
    Cookies.set('refreshToken', refreshToken);
  }
  Cookies.set('userRoleId', user?.role?.id);
  Cookies.set('userId', user?.id);
  Cookies.set('userDesignation', user?.designation?.name);
  Cookies.set('userRole', user?.role?.name);
  Cookies.set('userVertical', user?.vertical);
  Cookies.set('userDesignationLevel', user?.level);
  if (domino_enabled !== undefined && domino_enabled !== null) {
    Cookies.set('domino_enabled', String(domino_enabled));
  }
}

export function isDominoEnabled() {
  return Cookies.get('domino_enabled') !== 'false';
}

export function clearAuthSession() {
  AUTH_COOKIE_NAMES.forEach((name) => Cookies.remove(name));
  localStorage.removeItem('accessToken');
}

export function clearUserPreferences() {
  localStorage.clear();
}

export function handlePostLoginStorage(newUserId) {
  if (newUserId == null) return;

  const newUserIdStr = String(newUserId);
  const previousUserId = localStorage.getItem(LAST_LOGGED_IN_USER_ID_KEY);

  if (previousUserId && previousUserId !== newUserIdStr) {
    clearUserPreferences();
  }

  localStorage.setItem(LAST_LOGGED_IN_USER_ID_KEY, newUserIdStr);
}

export function handleLogoutStorage() {
  clearAuthSession();
  clearUserPreferences();
}
